/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export var SdfAccordion = /*@__PURE__*/createReactComponent('sdf-accordion');
export var SdfActionArea = /*@__PURE__*/createReactComponent('sdf-action-area');
export var SdfActionMenu = /*@__PURE__*/createReactComponent('sdf-action-menu');
export var SdfAlert = /*@__PURE__*/createReactComponent('sdf-alert');
export var SdfAlertBanner = /*@__PURE__*/createReactComponent('sdf-alert-banner');
export var SdfAlertIcon = /*@__PURE__*/createReactComponent('sdf-alert-icon');
export var SdfAlertInline = /*@__PURE__*/createReactComponent('sdf-alert-inline');
export var SdfAlertToast = /*@__PURE__*/createReactComponent('sdf-alert-toast');
export var SdfAppLoader = /*@__PURE__*/createReactComponent('sdf-app-loader');
export var SdfAvatar = /*@__PURE__*/createReactComponent('sdf-avatar');
export var SdfBadge = /*@__PURE__*/createReactComponent('sdf-badge');
export var SdfBox = /*@__PURE__*/createReactComponent('sdf-box');
export var SdfBoxStack = /*@__PURE__*/createReactComponent('sdf-box-stack');
export var SdfBusyIndicator = /*@__PURE__*/createReactComponent('sdf-busy-indicator');
export var SdfButton = /*@__PURE__*/createReactComponent('sdf-button');
export var SdfButtonGroup = /*@__PURE__*/createReactComponent('sdf-button-group');
export var SdfButtonLayout = /*@__PURE__*/createReactComponent('sdf-button-layout');
export var SdfCalendar = /*@__PURE__*/createReactComponent('sdf-calendar');
export var SdfCard = /*@__PURE__*/createReactComponent('sdf-card');
export var SdfCardFooter = /*@__PURE__*/createReactComponent('sdf-card-footer');
export var SdfCardHeader = /*@__PURE__*/createReactComponent('sdf-card-header');
export var SdfCardHeaderAdvanced = /*@__PURE__*/createReactComponent('sdf-card-header-advanced');
export var SdfCardHeaderCollapsible = /*@__PURE__*/createReactComponent('sdf-card-header-collapsible');
export var SdfCarousel = /*@__PURE__*/createReactComponent('sdf-carousel');
export var SdfCarouselItem = /*@__PURE__*/createReactComponent('sdf-carousel-item');
export var SdfChart = /*@__PURE__*/createReactComponent('sdf-chart');
export var SdfCheckbox = /*@__PURE__*/createReactComponent('sdf-checkbox');
export var SdfCheckboxGroup = /*@__PURE__*/createReactComponent('sdf-checkbox-group');
export var SdfCloseButton = /*@__PURE__*/createReactComponent('sdf-close-button');
export var SdfColumnChart = /*@__PURE__*/createReactComponent('sdf-column-chart');
export var SdfCurrencyInput = /*@__PURE__*/createReactComponent('sdf-currency-input');
export var SdfDashboard = /*@__PURE__*/createReactComponent('sdf-dashboard');
export var SdfDashboardCell = /*@__PURE__*/createReactComponent('sdf-dashboard-cell');
export var SdfDataRing = /*@__PURE__*/createReactComponent('sdf-data-ring');
export var SdfDatePicker = /*@__PURE__*/createReactComponent('sdf-date-picker');
export var SdfDatePickerV2 = /*@__PURE__*/createReactComponent('sdf-date-picker-v2');
export var SdfExpandableBox = /*@__PURE__*/createReactComponent('sdf-expandable-box');
export var SdfFileUploader = /*@__PURE__*/createReactComponent('sdf-file-uploader');
export var SdfFlagLayout = /*@__PURE__*/createReactComponent('sdf-flag-layout');
export var SdfFloatingPane = /*@__PURE__*/createReactComponent('sdf-floating-pane');
export var SdfFloatingPanePortal = /*@__PURE__*/createReactComponent('sdf-floating-pane-portal');
export var SdfFocusPane = /*@__PURE__*/createReactComponent('sdf-focus-pane');
export var SdfFormControlLayout = /*@__PURE__*/createReactComponent('sdf-form-control-layout');
export var SdfGrid = /*@__PURE__*/createReactComponent('sdf-grid');
export var SdfHelpText = /*@__PURE__*/createReactComponent('sdf-help-text');
export var SdfHomePageLayout = /*@__PURE__*/createReactComponent('sdf-home-page-layout');
export var SdfIcon = /*@__PURE__*/createReactComponent('sdf-icon');
export var SdfIconButton = /*@__PURE__*/createReactComponent('sdf-icon-button');
export var SdfIconLegacy = /*@__PURE__*/createReactComponent('sdf-icon-legacy');
export var SdfIconStack = /*@__PURE__*/createReactComponent('sdf-icon-stack');
export var SdfInlineModal = /*@__PURE__*/createReactComponent('sdf-inline-modal');
export var SdfInput = /*@__PURE__*/createReactComponent('sdf-input');
export var SdfLayoutJustifyEdge = /*@__PURE__*/createReactComponent('sdf-layout-justify-edge');
export var SdfLayoutListItem = /*@__PURE__*/createReactComponent('sdf-layout-list-item');
export var SdfLayoutRow = /*@__PURE__*/createReactComponent('sdf-layout-row');
export var SdfLayoutThreeCol = /*@__PURE__*/createReactComponent('sdf-layout-three-col');
export var SdfLayoutTwoCol = /*@__PURE__*/createReactComponent('sdf-layout-two-col');
export var SdfLineChart = /*@__PURE__*/createReactComponent('sdf-line-chart');
export var SdfLink = /*@__PURE__*/createReactComponent('sdf-link');
export var SdfMenu = /*@__PURE__*/createReactComponent('sdf-menu');
export var SdfMenuDivider = /*@__PURE__*/createReactComponent('sdf-menu-divider');
export var SdfMenuItem = /*@__PURE__*/createReactComponent('sdf-menu-item');
export var SdfMenuTitle = /*@__PURE__*/createReactComponent('sdf-menu-title');
export var SdfMfeLoader = /*@__PURE__*/createReactComponent('sdf-mfe-loader');
export var SdfMiniCard = /*@__PURE__*/createReactComponent('sdf-mini-card');
export var SdfMultiSelect = /*@__PURE__*/createReactComponent('sdf-multi-select');
export var SdfPageHeaderLayout = /*@__PURE__*/createReactComponent('sdf-page-header-layout');
export var SdfPageLayout = /*@__PURE__*/createReactComponent('sdf-page-layout');
export var SdfPagination = /*@__PURE__*/createReactComponent('sdf-pagination');
export var SdfPhoneNumberInput = /*@__PURE__*/createReactComponent('sdf-phone-number-input');
export var SdfPieChart = /*@__PURE__*/createReactComponent('sdf-pie-chart');
export var SdfProgressBar = /*@__PURE__*/createReactComponent('sdf-progress-bar');
export var SdfPromoBox = /*@__PURE__*/createReactComponent('sdf-promo-box');
export var SdfQuickStat = /*@__PURE__*/createReactComponent('sdf-quick-stat');
export var SdfRadioButton = /*@__PURE__*/createReactComponent('sdf-radio-button');
export var SdfRadioGroup = /*@__PURE__*/createReactComponent('sdf-radio-group');
export var SdfReadonlyField = /*@__PURE__*/createReactComponent('sdf-readonly-field');
export var SdfScroller = /*@__PURE__*/createReactComponent('sdf-scroller');
export var SdfSearch = /*@__PURE__*/createReactComponent('sdf-search');
export var SdfSegmentFiller = /*@__PURE__*/createReactComponent('sdf-segment-filler');
export var SdfSegmentedControl = /*@__PURE__*/createReactComponent('sdf-segmented-control');
export var SdfSelect = /*@__PURE__*/createReactComponent('sdf-select');
export var SdfSelectGroup = /*@__PURE__*/createReactComponent('sdf-select-group');
export var SdfSelectItem = /*@__PURE__*/createReactComponent('sdf-select-item');
export var SdfSelectItemList = /*@__PURE__*/createReactComponent('sdf-select-item-list');
export var SdfSelectList = /*@__PURE__*/createReactComponent('sdf-select-list');
export var SdfSelectOption = /*@__PURE__*/createReactComponent('sdf-select-option');
export var SdfSelectSimple = /*@__PURE__*/createReactComponent('sdf-select-simple');
export var SdfShimmer = /*@__PURE__*/createReactComponent('sdf-shimmer');
export var SdfSkeleton = /*@__PURE__*/createReactComponent('sdf-skeleton');
export var SdfSlider = /*@__PURE__*/createReactComponent('sdf-slider');
export var SdfSpinner = /*@__PURE__*/createReactComponent('sdf-spinner');
export var SdfSpotIllustration = /*@__PURE__*/createReactComponent('sdf-spot-illustration');
export var SdfSuperTitle = /*@__PURE__*/createReactComponent('sdf-super-title');
export var SdfSwitch = /*@__PURE__*/createReactComponent('sdf-switch');
export var SdfTab = /*@__PURE__*/createReactComponent('sdf-tab');
export var SdfTabGroup = /*@__PURE__*/createReactComponent('sdf-tab-group');
export var SdfTable = /*@__PURE__*/createReactComponent('sdf-table');
export var SdfTag = /*@__PURE__*/createReactComponent('sdf-tag');
export var SdfTextEditor = /*@__PURE__*/createReactComponent('sdf-text-editor');
export var SdfTextarea = /*@__PURE__*/createReactComponent('sdf-textarea');
export var SdfTimePicker = /*@__PURE__*/createReactComponent('sdf-time-picker');
export var SdfTimePickerV2 = /*@__PURE__*/createReactComponent('sdf-time-picker-v2');
export var SdfTimeSpinner = /*@__PURE__*/createReactComponent('sdf-time-spinner');
export var SdfTimeline = /*@__PURE__*/createReactComponent('sdf-timeline');
export var SdfTimelineEvent = /*@__PURE__*/createReactComponent('sdf-timeline-event');
export var SdfToggle = /*@__PURE__*/createReactComponent('sdf-toggle');
export var SdfTooltip = /*@__PURE__*/createReactComponent('sdf-tooltip');
export var SdfViewStack = /*@__PURE__*/createReactComponent('sdf-view-stack');
export var SdfWizardLayout = /*@__PURE__*/createReactComponent('sdf-wizard-layout');
export var SdfWizardStepsVertical = /*@__PURE__*/createReactComponent('sdf-wizard-steps-vertical');
export var SdfWizardStepsVerticalItem = /*@__PURE__*/createReactComponent('sdf-wizard-steps-vertical-item');